import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '../controls/Controls';
import { Col, Flex, Row } from 'antd';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftOutlined, DownOutlined, UpOutlined } from '@ant-design/icons';

export const FooterTitle = (props) => {
  return <div className="footer-title-comp">{props.children}</div>;
};

export const MainTitle = (props) => {
  const navigate = useNavigate();
  return (
    <div className="main-comp">
      {props.backAction ? (
        <Row>
          <Col
            span={24}
            xs={23}
            style={{ display: 'flex', alignItems: 'center', gap: '5px' }}
          >
            <IconButton
              type="button"
              key={`icon-btn-back-action`}
              onClick={() => navigate(-1)}
              tooltip={'Späť'}
              icon={<ArrowLeftOutlined />}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                marginBottom: '10px',
              }}
            />
            <h1 className="main-title">{props.title}</h1>
          </Col>
          <Col span={2} xs={1}>
            {props.actions && props.actions.length > 0 && (
              <Flex
                justify="end"
                style={{
                  height: '100%',
                }}
              >
                {props.actions.map((action) => (
                  <IconButton
                    type="button"
                    key={`icon-btn-${action.title}`}
                    onClick={action.onClick}
                    tooltip={action.title}
                    icon={action.icon}
                    style={{
                      ...action.style,
                    }}
                  />
                ))}
              </Flex>
            )}
          </Col>
        </Row>
      ) : (
        <Row>
          <Col span={22}>
            <h1 className="main-title">{props.title}</h1>
          </Col>
          <Col span={2}>
            {props.actions && props.actions.length > 0 && (
              <Flex
                align="center"
                justify="end"
                style={{
                  height: '100%',
                }}
              >
                {props.actions.map((action) => (
                  <IconButton
                    type="button"
                    key={`icon-btn-${action.title}`}
                    onClick={action.onClick}
                    tooltip={action.title}
                    icon={action.icon}
                    style={{
                      ...action.style,
                    }}
                  />
                ))}
              </Flex>
            )}
          </Col>
        </Row>
      )}
    </div>
  );
};
MainTitle.propTypes = {
  title: PropTypes.string,
  backAction: PropTypes.bool,
  actions: PropTypes.array, // [{onCLick, title, icon}]
};

export const MainTitleShowable = (props) => {
  return (
    <div className="main-comp">
      <Row>
        <Col span={20}>
          <h4
            className="main-title"
            style={{ cursor: 'pointer' }}
            onClick={() => props.toggle(props.title)}
          >
            {props.title}
          </h4>
        </Col>
        <Col span={4}>
          <Flex
            align="center"
            justify="end"
            style={{
              height: '100%',
            }}
          >
            {props.visible && (
              <DownOutlined onClick={() => props.toggle(props.title)} />
            )}
            {!props.visible && (
              <UpOutlined onClick={() => props.toggle(props.title)} />
            )}
          </Flex>
        </Col>
      </Row>
    </div>
  );
};
MainTitleShowable.propTypes = {
  title: PropTypes.string,
  visible: PropTypes.bool,
  toggle: PropTypes.func,
};
